import type { FortuneIconProps } from '@/app_components/icons/constants';

export const ConferencesStar = ({ className, ...rest }: FortuneIconProps) => (
  <svg
    className={className}
    fill='none'
    height='24'
    viewBox='0 0 24 24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <title>Conferences Star</title>
    <path
      d='M5.99995 20C5.99995 21.1045 5.10452 22 3.99995 22C2.89538 22 1.99995 21.1045 1.99995 20C1.99995 18.8954 2.89538 18 3.99995 18C5.10452 18 5.99995 18.8954 5.99995 20Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M11.017 2.81395C11.0598 2.58456 11.1815 2.37737 11.3611 2.22827C11.5406 2.07917 11.7666 1.99756 12 1.99756C12.2333 1.99756 12.4593 2.07917 12.6389 2.22827C12.8184 2.37737 12.9401 2.58456 12.983 2.81395L14.034 8.37195C14.1086 8.7671 14.3006 9.13057 14.585 9.41492C14.8693 9.69928 15.2328 9.89131 15.628 9.96595L21.186 11.017C21.4153 11.0598 21.6225 11.1815 21.7716 11.3611C21.9207 11.5406 22.0023 11.7666 22.0023 12C22.0023 12.2333 21.9207 12.4593 21.7716 12.6389C21.6225 12.8184 21.4153 12.9401 21.186 12.983L15.628 14.034C15.2328 14.1086 14.8693 14.3006 14.585 14.585C14.3006 14.8693 14.1086 15.2328 14.034 15.628L12.983 21.186C12.9401 21.4153 12.8184 21.6225 12.6389 21.7716C12.4593 21.9207 12.2333 22.0023 12 22.0023C11.7666 22.0023 11.5406 21.9207 11.3611 21.7716C11.1815 21.6225 11.0598 21.4153 11.017 21.186L9.96595 15.628C9.89131 15.2328 9.69928 14.8693 9.41492 14.585C9.13057 14.3006 8.7671 14.1086 8.37195 14.034L2.81395 12.983C2.58456 12.9401 2.37737 12.8184 2.22827 12.6389C2.07917 12.4593 1.99756 12.2333 1.99756 12C1.99756 11.7666 2.07917 11.5406 2.22827 11.3611C2.37737 11.1815 2.58456 11.0598 2.81395 11.017L8.37195 9.96595C8.7671 9.89131 9.13057 9.69928 9.41492 9.41492C9.69928 9.13057 9.89131 8.7671 9.96595 8.37195L11.017 2.81395Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M20 1.99995V5.99995M22 3.99995H18M11.017 2.81395C11.0598 2.58456 11.1815 2.37737 11.3611 2.22827C11.5406 2.07917 11.7666 1.99756 12 1.99756C12.2333 1.99756 12.4593 2.07917 12.6389 2.22827C12.8184 2.37737 12.9401 2.58456 12.983 2.81395L14.034 8.37195C14.1086 8.7671 14.3006 9.13057 14.585 9.41492C14.8693 9.69928 15.2328 9.89131 15.628 9.96595L21.186 11.017C21.4153 11.0598 21.6225 11.1815 21.7716 11.3611C21.9207 11.5406 22.0023 11.7666 22.0023 12C22.0023 12.2333 21.9207 12.4593 21.7716 12.6389C21.6225 12.8184 21.4153 12.9401 21.186 12.983L15.628 14.034C15.2328 14.1086 14.8693 14.3006 14.585 14.585C14.3006 14.8693 14.1086 15.2328 14.034 15.628L12.983 21.186C12.9401 21.4153 12.8184 21.6225 12.6389 21.7716C12.4593 21.9207 12.2333 22.0023 12 22.0023C11.7666 22.0023 11.5406 21.9207 11.3611 21.7716C11.1815 21.6225 11.0598 21.4153 11.017 21.186L9.96595 15.628C9.89131 15.2328 9.69928 14.8693 9.41492 14.585C9.13057 14.3006 8.7671 14.1086 8.37195 14.034L2.81395 12.983C2.58456 12.9401 2.37737 12.8184 2.22827 12.6389C2.07917 12.4593 1.99756 12.2333 1.99756 12C1.99756 11.7666 2.07917 11.5406 2.22827 11.3611C2.37737 11.1815 2.58456 11.0598 2.81395 11.017L8.37195 9.96595C8.7671 9.89131 9.13057 9.69928 9.41492 9.41492C9.69928 9.13057 9.89131 8.7671 9.96595 8.37195L11.017 2.81395ZM5.99995 20C5.99995 21.1045 5.10452 22 3.99995 22C2.89538 22 1.99995 21.1045 1.99995 20C1.99995 18.8954 2.89538 18 3.99995 18C5.10452 18 5.99995 18.8954 5.99995 20Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeOpacity='0.8'
      strokeWidth='1.5'
    />
  </svg>
);

export const ConferencesPeople = ({ className, ...rest }: FortuneIconProps) => (
  <svg
    className={className}
    fill='none'
    height='24'
    viewBox='0 0 24 24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <title>Conferences People</title>
    <path
      d='M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21H16Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M16 3.128C16.8578 3.35037 17.6174 3.85126 18.1597 4.55206C18.702 5.25286 18.9962 6.11389 18.9962 7C18.9962 7.88611 18.702 8.74714 18.1597 9.44794C17.6174 10.1487 16.8578 10.6496 16 10.872M22 21C22 20.219 22 19 22 19C21.9993 18.1137 21.7044 17.2528 21.1614 16.5523C20.6184 15.8519 19.8581 15.3516 19 15.13M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21H16ZM13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeOpacity='0.8'
      strokeWidth='1.5'
    />
  </svg>
);

export const ConferencesVideo = ({ className, ...rest }: FortuneIconProps) => (
  <svg
    className={className}
    fill='none'
    height='24'
    viewBox='0 0 24 24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <title>Conferences Video</title>
    <path
      d='M16 13L21.223 16.482C21.2983 16.5321 21.3858 16.5608 21.4761 16.5652C21.5664 16.5695 21.6563 16.5492 21.736 16.5065C21.8157 16.4639 21.8824 16.4003 21.9289 16.3228C21.9754 16.2452 22 16.1564 22 16.066V7.87C22 7.78202 21.9768 7.6956 21.9328 7.61945C21.8887 7.5433 21.8253 7.48012 21.7491 7.4363C21.6728 7.39248 21.5863 7.36956 21.4983 7.36985C21.4103 7.37015 21.324 7.39366 21.248 7.438L16 10.5'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M14 6H4C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H14C15.1046 18 16 17.1046 16 16V8C16 6.89543 15.1046 6 14 6Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M16 13L21.223 16.482C21.2983 16.5321 21.3858 16.5608 21.4761 16.5652C21.5664 16.5695 21.6563 16.5492 21.736 16.5065C21.8157 16.4639 21.8824 16.4003 21.9289 16.3228C21.9754 16.2452 22 16.1564 22 16.066V7.87C22 7.78202 21.9768 7.6956 21.9328 7.61945C21.8887 7.5433 21.8253 7.48012 21.7491 7.4363C21.6728 7.39248 21.5863 7.36956 21.4983 7.36985C21.4103 7.37015 21.324 7.39366 21.248 7.438L16 10.5M4 6H14C15.1046 6 16 6.89543 16 8V16C16 17.1046 15.1046 18 14 18H4C2.89543 18 2 17.1046 2 16V8C2 6.89543 2.89543 6 4 6Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeOpacity='0.8'
      strokeWidth='1.5'
    />
  </svg>
);

export const ConferencesGlobe = ({ className, ...rest }: FortuneIconProps) => (
  <svg
    className={className}
    fill='none'
    height='22'
    viewBox='0 0 22 22'
    width='22'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <title>Conferences Globe</title>
    <path
      d='M10.75 0.75C5.22715 0.75 0.75 5.22715 0.75 10.75H6.75C6.75 7.02674 8.18223 3.44615 10.75 0.75Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M10.75 0.75C8.18223 3.44615 6.75 7.02674 6.75 10.75H14.75C14.75 7.02674 13.3178 3.44615 10.75 0.75Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M20.75 10.75C20.75 5.22715 16.2728 0.75 10.75 0.75C13.3178 3.44615 14.75 7.02674 14.75 10.75H20.75Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M10.75 20.75C16.2728 20.75 20.75 16.2728 20.75 10.75H14.75C14.75 14.4733 13.3178 18.0538 10.75 20.75Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M6.75 10.75C6.75 14.4733 8.18223 18.0538 10.75 20.75C13.3178 18.0538 14.75 14.4733 14.75 10.75H6.75Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M0.75 10.75C0.75 16.2728 5.22715 20.75 10.75 20.75C8.18223 18.0538 6.75 14.4733 6.75 10.75H0.75Z'
      fill='currentColor'
      fillOpacity='0.1'
      stroke='none'
    />
    <path
      d='M20.75 10.75C20.75 16.2728 16.2728 20.75 10.75 20.75M20.75 10.75C20.75 5.22715 16.2728 0.75 10.75 0.75M20.75 10.75H0.75M20.75 10.75H14.75M10.75 20.75C5.22715 20.75 0.75 16.2728 0.75 10.75M10.75 20.75C8.18223 18.0538 6.75 14.4733 6.75 10.75M10.75 20.75C13.3178 18.0538 14.75 14.4733 14.75 10.75M0.75 10.75C0.75 5.22715 5.22715 0.75 10.75 0.75M0.75 10.75H6.75M10.75 0.75C8.18223 3.44615 6.75 7.02674 6.75 10.75M10.75 0.75C13.3178 3.44615 14.75 7.02674 14.75 10.75M6.75 10.75H14.75'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeOpacity='0.8'
      strokeWidth='1.5'
    />
  </svg>
);
